export default __webpack_public_path__ + "static/media/cplogo.d7d101c5.png";